import {initWebComponent} from "@/helpers/web-component-helper";
import {addLayer, getLayerByName} from "@/helpers/ol/ol-layer-helper";
import {toggleGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";
import {loadInfoItemGeometryMeasure} from "@/helpers/layer/info/layer-info-info-item-geometry-measure-helper";
import {getFeatureByIndex} from "@/helpers/main-tab-helper";
import {hideElementsBySelector} from "@/helpers/element-helper";
import {clearBuffer} from "@/helpers/measure/measure-buffer-helper";

export class LayerInfoInfoItemGeometryMeasureBackButton extends HTMLElement {
    constructor(){
        super();
        const template = document.createElement('template');

        template.innerHTML = `<button title="Terug naar informatie" class="btn float-right icon-btn btn-outline-secondary ml-2 mr-1 btn float-right btn-sm">
                    <i class="fa fa-caret-left fa-lg"></i>
                    <i class="fa fa-list"></i> 
                </button>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            document.querySelector('layer-info-info').classList.remove('d-none')
            document.querySelector('layer-info-info-geometry-measure').classList.add('d-none')
            clearBuffer()
        })
    }
}

